var DEALS_SETTINGS_LOAD_SUCCESS = 'PAYOUT_REQUISITES_LOAD_SUCCESS';
var DEALS_SETTINGS_SAVE_SUCCESS = 'PAYOUT_REQUISITES_SAVE_SUCCESS';
var DEALS_SETTINGS_LOAD_URL = '/user/deal-settings/load';
var DEALS_SETTINGS_SAVE_URL = '/user/deal-settings/save';
var REDUCER_DEALS_SETTINGS_NAME = 'dealSettings';
var USER_PROFILE_DEALS_SETTINGS_URL = '/user/deals-settings';
export { DEALS_SETTINGS_LOAD_SUCCESS, DEALS_SETTINGS_SAVE_SUCCESS, DEALS_SETTINGS_LOAD_URL, DEALS_SETTINGS_SAVE_URL, REDUCER_DEALS_SETTINGS_NAME, USER_PROFILE_DEALS_SETTINGS_URL };